import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { skipSet } from '../../store/filterSlice';
import { PAGE_LIMIT } from '../../config';
import useApiList from '../../hooks/useApiList';
import Loader from '../common/Loader';
import Error from '../common/Error';
import Pager from '../common/Pager';
import ActivityItem from './ActivityItem';
import './ActivityList.css';
import List from '../common/List';
import ModeSwitch from '../common/ModeSwitch';
import FilterInfo from '../filter/FilterInfo';
import { activityDate2Human } from '../../utils/dateTime';

const ActivityList = ({ event }) => {
	const { i18n } = useTranslation();
	const dispatch = useDispatch();
	const lang = i18n.language;
	const method = '/activities';
	const limit = PAGE_LIMIT;
    const skip = useSelector(state => state.filter.skip);
	const find = useSelector(state => state.filter.find);
	const filterDates = useSelector(state => state.filter.dates);
	const categories = useSelector(state => state.filter.categories);
	const countries = useSelector(state => state.filter.countries);
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip, event: event._id, categories, lang, countries, dates: filterDates });
	const [ dates, setDates ] = useState([]);
	const [ activities, setActivities ] = useState([]);

	useEffect(() => {
		if(!data) return;
		let dates = [];
		let activities = [];
		if(Array.isArray(data.activities)) {
			activities = data.activities;
			let date = '-';
			data.activities.forEach(a => {
				if(!a.date.startsWith(date)) {
					date = a.date.split(' ')[0];
					dates.push(date);
				}
			});
		}
		setDates(dates);
		setActivities(activities);
	}, [ data ]);

	// Для переключения страниц из пейджера
	const setSkip = (skip) => {
		dispatch(skipSet(skip));
	};

	return (
		<div className='Content-main ActivityList'>
			<div className='desktop'>
	    		<h1>{event.name[lang]}</h1>
			</div>

			<ModeSwitch data={data}/>

			{isLoading && <Loader/>}
			{error && <Error error={error}/>}

			<FilterInfo data={data}/>

			{dates.map(date => (
			<div key={date}>
				<h2>{activityDate2Human(date, lang, false)}</h2>
				<List>
					{activities.map(activity => (
					<ActivityItem
						key={activity._id}
						date={date}
						activity={activity}
					/>))}
				</List>
			</div>))}
			{data && <Pager skip={skip} setSkip={setSkip} limit={limit} total={data.total}/>}
		</div>
	);
};

ActivityList.propTypes = {
    event: PropTypes.object.isRequired,
};

export default ActivityList;
